import * as ActionTypes from '../actions/ActionTypes';
import { getFieldDefinition } from '../constants/templateEditor/KnowledgeBaseSettingsModule';
export default function templateEditorReloadPreviewOnSave(state = false, action) {
  switch (action.type) {
    case ActionTypes.TEMPLATE_EDITOR_UPDATE_FORM_SUCCESS:
      {
        const {
          fieldPath,
          navItem
        } = action.payload;
        if (navItem && fieldPath) {
          const field = getFieldDefinition(fieldPath, navItem);
          if (field._requiresPreviewRefresh) {
            return true;
          }
        }
        return state;
      }
    case ActionTypes.TEMPLATE_EDITOR_TOGGLE_CATEGORY_ON_HOME_PAGE:
    case ActionTypes.TEMPLATE_EDITOR_UPDATE_CATEGORY_ICON:
    case ActionTypes.TEMPLATE_EDITOR_UPDATE_CATEGORY_IMAGE:
    case ActionTypes.TEMPLATE_EDITOR_UPDATE_CATEGORY_IMAGE_TYPE:
      {
        return true;
      }
    case ActionTypes.UPDATE_TEMPLATE_SETTINGS_SUCCESS:
      {
        return false;
      }
    default:
      return state;
  }
}